import React from 'react';
import IfCanAccess from 'src/components/widgets/ifCanAccess/ifCanAccess';
import { T } from 'src/shared/helpers';
import { usePageTitle } from 'src/shared/hooks/usePageTitle';
import TestingCustomizer from './testingCustomizer';

export default function TestingCustomizerIndex() {
    usePageTitle(T._('Preview', 'Admin'));
    return (
        <IfCanAccess permission='PRODUCTS'>
            <TestingCustomizer />
        </IfCanAccess>
    );
}
